import { type ReactNode } from 'react'
import { bookingUrl, mapsDirectionsUrl } from '#app/utils/constants.ts'

export function ViewfinderBook({ className = '' }: { className?: string }) {
	return (
		<a href={bookingUrl} className={`viewfinder ${className}`.trim()}>
			<span className="corner tl" aria-hidden="true" />
			<span className="corner tr" aria-hidden="true" />
			<span className="corner bl" aria-hidden="true" />
			<span className="corner br" aria-hidden="true" />
			Marcar sessão
		</a>
	)
}

export function OilThreadBook() {
	return (
		<a
			href={bookingUrl}
			className="oil-thread font-display inline-flex items-center gap-3 pb-1 text-2xl text-oil no-underline md:text-3xl"
		>
			Marcar sessão
			<svg width="36" height="12" viewBox="0 0 36 12" aria-hidden="true">
				<path
					d="M1 6h28"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.4"
				/>
				<path
					d="M24 1.5L33 6l-9 4.5"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.4"
					strokeLinejoin="round"
				/>
			</svg>
		</a>
	)
}

export function ShearBook({
	children = 'Marcar sessão',
}: {
	children?: ReactNode
}) {
	return (
		<a href={bookingUrl} className="shear-band">
			<span>{children}</span>
			<span aria-hidden="true">→</span>
		</a>
	)
}

export function StampMaps() {
	return (
		<a
			href={mapsDirectionsUrl}
			className="stamp"
			target="_blank"
			rel="noreferrer"
		>
			Como chegar
		</a>
	)
}
